import { buildKit, validateCharacter, type CharacterManifest, type FighterKit } from "@arena/shared";
import { DANTE } from "./dante.ts";
import { GANDHI } from "./gandhi.ts";

import { MUSSOLINI } from "./mussolini.ts";
import {KAFKA,KAFKA_BEETLE_KIT} from './kafka.ts';
import {LOVECRAFT,LOVECRAFT_SUMMONS} from './lovecraft.ts';
import {AURAMENNONE,AURAMENNONE_AURA_KIT,AURAMENNONE_HOPLITE} from './auramennone.ts';
import {CLEOPATRA} from './cleopatra.ts';
import {ANTONIETTA,ANTONIETTA_WIG_KIT} from './antonietta.ts';
import {GIOVANNA,GIOVANNA_HORSE_KIT} from './giovanna.ts';
export {GIOVANNA,GIOVANNA_BANNER,GIOVANNA_HORSE,GIOVANNA_HORSE_KIT,GIOVANNA_VOICES,voicesCommand} from './giovanna.ts';
export {ANTONIETTA,ANTONIETTA_BRIOCHE,ANTONIETTA_SPIN,ANTONIETTA_WIG,ANTONIETTA_WIG_KIT} from './antonietta.ts';
export {CLEOPATRA,CLEOPATRA_BATH,CLEOPATRA_CHARM,CLEOPATRA_POISON,charmedCommand} from './cleopatra.ts';
export {AURAMENNONE,AURAMENNONE_AURA,AURAMENNONE_AURA_KIT,AURAMENNONE_MAX_AURA_KIT,AURAMENNONE_PHALANX,AURAMENNONE_HOPLITE} from './auramennone.ts';
export {LOVECRAFT,LOVECRAFT_SUMMONS,LOVECRAFT_TENTACLE,type LovecraftCreatureKind} from './lovecraft.ts';
export { DANTE, GANDHI, MUSSOLINI, KAFKA };
export {KAFKA_METAMORPH,KAFKA_BEETLE_KIT} from './kafka.ts';

/**
 * The roster: historical figures in caricature (docs/DECISIONS.md, D34, D37).
 * New champions are a manifest each, added here.
 */
export const CHARACTERS: readonly CharacterManifest[] = [DANTE, GANDHI, MUSSOLINI, KAFKA, LOVECRAFT, AURAMENNONE, CLEOPATRA, ANTONIETTA, GIOVANNA];

/** Museum display order by historical period, then by birth date (Kafka precedes Mussolini in 1883). */
export const MUSEUM_CHAMPIONS: readonly CharacterManifest[] = [
  AURAMENNONE, CLEOPATRA, DANTE, GIOVANNA, ANTONIETTA, GANDHI, KAFKA, MUSSOLINI, LOVECRAFT,
];

export const DEFAULT_CHARACTER_ID = DANTE.id;

// A broken manifest must stop the server and the client at startup, not mid-match.
for (const c of CHARACTERS) {
  const errors = validateCharacter(c);
  if (errors.length > 0) throw new Error(`Campione ${c.id} non valido: ${errors.join("; ")}`);
}

const KITS: ReadonlyMap<string, FighterKit> = new Map(CHARACTERS.map((c) => [c.id, buildKit(c)]));

export function findCharacter(id: string): CharacterManifest | undefined {
  return CHARACTERS.find((c) => c.id === id);
}

/** A player who has not picked a champion yet (`characterId` empty, D49): the default champion's body, no attack. */
export const GHOST_KIT: FighterKit = Object.freeze({ ...KITS.get(DEFAULT_CHARACTER_ID)!, id: "", ghost: true as const });

/** The kit (moves and movement numbers) of a champion; the ghost's with no champion; the default champion for an unknown id. */
export function kitOf(id: string,metamorphTicks=0): FighterKit {
  if(id==="")return GHOST_KIT;
  if(metamorphTicks>0){const form=FORMS.get(id);if(form)return form;}
  return KITS.get(id) ?? KITS.get(DEFAULT_CHARACTER_ID)!;
}

/** A champion's other kit while its timed form lasts (`metamorphTicks` > 0): Kafka's beetle, Auramennone's aura, Maria Antonietta's wig, Giovanna's horse. */
const FORMS: ReadonlyMap<string, FighterKit> = new Map([["kafka", KAFKA_BEETLE_KIT], ["auramennone", AURAMENNONE_AURA_KIT], ["antonietta", ANTONIETTA_WIG_KIT], ["giovanna", GIOVANNA_HORSE_KIT]]);

/** A servant a champion summons: what it is, its kit, its health and how long it lasts. */
export interface SummonSpec {
  readonly manifest: CharacterManifest;
  readonly kit: FighterKit;
  readonly hp: number;
  readonly ticks: number;
}

const SUMMONS: ReadonlyMap<string, SummonSpec> = new Map<string, SummonSpec>([
  ["migo", LOVECRAFT_SUMMONS.migo],
  ["shoggoth", LOVECRAFT_SUMMONS.shoggoth],
  ["hoplite", AURAMENNONE_HOPLITE],
]);

/** The servant of a kind (`CreatureState.kind`), whoever summoned it. */
export function summonOf(kind: string): SummonSpec | undefined {
  return SUMMONS.get(kind);
}
